<template>
	<div class="venuecategory">
		<el-button v-if="permissionAdd" type="primary" class="AddVillageBtn" @click="handleAdd()"><i class="el-icon-edit"></i> 新增</el-button>
		<div class="fr">
			<el-input v-model="name1" placeholder="请输入场馆类别名称" style="width:200px" @keyup.enter.native="handleSearch"></el-input>
			<el-button slot="append" icon="el-icon-search" type="primary" @keyup.enter="handleSearch" @click="handleSearch" style="margin-left:10px;">搜索</el-button>
		</div>
		<el-table v-if="permissionShow" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :data="tableData" border style="width: 100%;" height="calc(100% - 100px)" row-key="vt_id">
			<el-table-column prop="vt_name" label="名称" sortable align="left" show-overflow-tooltip min-width="180">
			</el-table-column>
			<el-table-column prop="vt_icon" label="图标" sortable align="center" show-overflow-tooltip min-width="160">
				<template slot-scope="scope">
					<img
						:src="scope.row.vt_icon"
						height="34px"
						class="showImg"
						v-if="scope.row.vt_icon"
						@click="showImg(scope.row)">
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" min-width="180">
				<template slot-scope="scope">
					<el-button @click="handleDetail(scope.row)" type="text" size="small">查看</el-button>
					<el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
					<el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 新增 -->
		<el-dialog 
			v-elDragDialog
			:visible.sync="AddDialogTableVisible"
			title="新增场馆类别" 
			@closed="AddDialogClosed('AddForm')"
			:close-on-click-modal="false">
			<!-- 表单 -->
			<el-form ref="AddForm" :model="AddForm" label-width="80px" :rules="AddRules" style="width:100%;" >
				<el-form-item label="类别名称" prop="vt_name" >
					<el-input v-model="AddForm.vt_name"></el-input>
				</el-form-item>
				<el-form-item label="类别图标" prop="vt_icon">
					<el-upload
						:class="{disabled: addUploadDisabled}"
						:action="uploadAddress"
						list-type="picture-card"
						name="file"
						:limit="1"
						ref="AddUpload"
						:http-request="customUploadCover"
						:on-preview="handlePreview" 
						:on-remove="removeAddUpload"
						:file-list="AddFileList"
						:before-upload="beforeUploadCover">
						<i class="el-icon-plus"></i>
					</el-upload>
						<!-- :on-success="successAddUpload" -->
				</el-form-item>
				<el-form-item label="父级" prop="vt_fid">
					<el-select v-model="AddForm.vt_fid" clearable placeholder="请选择（不选则默认为第一级）" style="width:100%;" @change="ChangeFid('AddForm')">
						<el-option
							v-for="item in selectType"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
					<p style="margin:0;color:red" v-if="false">不选则默认为第一级</p>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitAddForm('AddForm')">提交</el-button>
					<el-button @click="cancleAddForm('AddForm')">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 编辑 -->
		<el-dialog 
			v-elDragDialog
			:visible.sync="EditDialogTableVisible"
			title="修改场馆类别" 
			@closed="EditDialogClosed('EditForm')"
			:close-on-click-modal="false">
			<!-- 表单 -->
			<el-form ref="EditForm" :model="EditForm" label-width="80px" :rules="EditRules" style="width:100%;" >
				<el-form-item label="类别名称" prop="vt_name" >
					<el-input v-model="EditForm.vt_name"></el-input>
				</el-form-item>
				<el-form-item label="类别图标" prop="vt_icon">
					<el-upload
						:class="{disabled: editUploadDisabled}"
						:action="uploadAddress"
						list-type="picture-card"
						name="file"
						:limit="1"
						ref="EditUpload"
						:http-request="customEditUpload"
						:on-preview="handlePreview"
						:on-remove="removeEditUpload"
						:file-list="EditFileList"
						:before-upload="beforeUploadCover">
						<i class="el-icon-plus"></i>
					</el-upload>
						<!-- :on-success="successEditUpload" -->
				</el-form-item>
				<el-form-item label="父级" prop="vt_fid">
					<el-select v-model="EditForm.vt_fid" clearable placeholder="请选择（不选则默认为第一级）" style="width:100%;" @change="ChangeFid('EditForm')">
						<el-option
							v-for="item in selectType"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
					<p style="margin:0;color:red" v-if="false">不选则默认为第一级</p>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitEditForm('EditForm')">提交</el-button>
					<el-button @click="cancleEditForm('EditForm')">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 查看详情 -->
		<el-dialog 
			v-elDragDialog
			:visible.sync="DetailDialogTableVisible"
			title="查看改场馆类别详情" 
			@closed="DetailDialogClosed('DetailForm')"
			:close-on-click-modal="false">
			<!-- 表单 -->
			<el-form ref="DetailForm" :model="DetailForm" label-width="80px" style="width:100%;" >
				<el-form-item label="类别名称" prop="vt_name" >
					<el-input v-model="DetailForm.vt_name" disabled></el-input>
				</el-form-item>
				<el-form-item label="类别图标" prop="vt_icon">
					<el-upload
						disabled
						:class="{disabled: detailUploadDisabled}"
						:action="uploadAddress"
						list-type="picture-card"
						:limit="1"
						ref="EditUpload"
						:on-preview="handlePreview"
						:file-list="DetailFileList">
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="父级" prop="vt_fid">
					<el-select v-model="DetailForm.vt_fid" clearable placeholder="请选择（不选则默认为第一级）" style="width:100%;" disabled>
						<el-option
							v-for="item in selectType"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</el-dialog>

		<!-- 放大首图 -->
		<el-dialog 
			:visible.sync="ImgDialog"
			:title="currentImg.title" 
			width="200px"
			:close-on-click-modal="false">
			<img :src="currentImg.src" width="100%">
		</el-dialog>
	</div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'
// 引用拖拽
import elDragDialog from '@/directive/el-dragDialog';

export default {
	name: 'venuecategory',
	directives: { elDragDialog }, // 拖拽指令
	data() {
		return {
			tableData: [],
			loading : true , // 加载条

			name1: '', // 请输入场馆类别名称
			total : 0, // 分页总条数
			start : 0, // 默认第一页
			limit : 0, // 每页10条
            searchData: {
                name1: ''
            },

			permissionShow: false, // 默认为false,根据权限是否显示
			permissionDetail: false, // 默认为false,根据权限是否查看
			permissionEdit: false, // 默认为false,根据权限是否修改
			permissionDelete: false, // 默认为false,根据权限是否删除
			permissionAdd: false, // 默认为false,根据权限是否新建

			selectType: [], // 父级类别

			// 新增
			AddFileList: [],
			AddDialogTableVisible : false,
			AddForm: {
				vt_name: '',
				vt_icon: '',
				vt_fid: '',
			},
			AddRules: {
				vt_name: [{required: true, message : '请输入类别名称', trigger: 'blur'}],
				vt_icon: [{required: true, message : '请选择图标', trigger: 'blur'}]
			},
			AddPreviewDialogVisible : false,
			AddPreviewDialogImageUrl : '',

			// 编辑
			EditFileList: [],
			EditDialogTableVisible : false,
			EditForm: {
				vt_name: '',
				vt_icon: '',
				vt_fid: '',
			},
			EditRules: {
				vt_name: [{required: true, message : '请输入类别名称', trigger: 'blur'}],
				vt_icon: [{required: true, message : '请选择图标', trigger: 'blur'}]
			},
			EditPreviewDialogVisible : false,
			EditPreviewDialogImageUrl : '',

			DetailDialogTableVisible : false,
			DetailFileList: [],
			DetailForm: {
				vt_name: '',
				vt_icon: '',
				vt_fid: '',
			},

			ImgDialog: false,
			uploadAddress : `${api.dev}/p/main/upload/image`,  // 上传图片的地址
			currentImg: {
				title: '',
				src: ''
			},
		}
	},
	methods: {
		/* 获取权限 */
		getSubPermission(){
			this.$http.get(`${api.dev}/p/permission/getSub`,{params:{access_token:getToken(), p_id: this.$route.params.id}}).then(res => {
				if(res.body.code == 200){
					res.body.content.forEach(item => {
						if(item.p_name.indexOf('显示') > -1){
							this.permissionShow = true;
						}else if(item.p_name.indexOf('新建') > -1){
							this.permissionAdd = true;
						}else if(item.p_name.indexOf('修改') > -1){
							this.permissionEdit = true;
						}else if(item.p_name.indexOf('详情') > -1){
							this.permissionDetail = true;
						}else if(item.p_name.indexOf('删除') > -1){
							this.permissionDelete = true;
						}
					})
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'});
					},2000)
				}
			})
		},
		/* 获取分页条数 */
		getLimit() {
			this.$http.post(`${api.dev}/p/main/preference/show`,{access_token:getToken()},{emulateJSON:true}).then(res => {
				if(res.body.code == 200) {
					this.limit = res.body.content.p_pagesize;
					this.getInfo();
				}else if(res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'});
					},2000)
				}
			})
		},
		/* 获取类别 */
		getType(){
			this.$http.get(`${api.dev}/p/main/drop/selectVenueType`,{params: {access_token: getToken(), type : 0, fid: 0}}).then(res => {
				if(res.body.code == 200){
					this.selectType = res.body.content;
				}else if (res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'});
					},2000)
				}
			})
		},
        /* 搜索 */
        handleSearch(){
            this.searchData = {
                name1: this.searchName
            };
            this.getInfo();
        },
		/* 获取数据 */
		getInfo(){
			this.$http.get(
				`${api.dev}/p/main/venue/type/show`,
				{
					params: {
						access_token: getToken(),
						start: this.start,
						limit : this.limit,
						name1 : this.searchData.name1
					}
				}
			).then(res => {
				if(res.body.code == 200) {
					res.body.content.records.forEach( i => {
						i.vt_icon = (i.vt_icon) ? `${api.address}${i.vt_icon}` : '';
						if(i.children && i.children.length > 0){
							i.children.forEach( j => {
								j.vt_icon = (j.vt_icon) ? `${api.address}${j.vt_icon}` : '';
							})
						}
					})
					this.tableData = res.body.content.records;
					this.total = res.body.content.total
					this.loading = false;
				}else if (res.body.code == 500) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
				}else if(res.body.code == 510) {
					this.$message({
						message: res.body.msg,
						type: 'error'
					});
					removeToken();
					setTimeout(function () {
						this.$router.push({path: '/login'});
					},2000)
				}
			})
		},
		/* 共用 -表格大图查看 */
		showImg(row){
			this.ImgDialog = true;
			this.currentImg.title = row.vt_name;
			this.currentImg.src = row.vt_icon;
		},
		/* 共用 -表单放大图片 */
		handlePreview(file) {
			this.ImgDialog = true;
			this.currentImg.title = '';
			this.currentImg.src = file.url;
		},
		/* 共用 -上传图片前 */
		beforeUploadCover(file) {
			const isLt5M = file.size / 1024 / 1024  < 5;
			if (['image/jpg', 'image/jpeg', 'image/bmp','image/png'].indexOf(file.type) == -1) {
				this.$message.error('请上传正确的图片格式');
				return false;
			}
			if (!isLt5M) {
				this.$message.error('上传图片大小不能超过5MB!');
				return false;
			}
		},
		/* 共用 -父级ID选择器改变时 */
		ChangeFid(form){
			if(form == 'AddForm'){
				if(this.AddForm.vt_fid){
				this.AddRules.vt_icon = [{required: false, message : '请选择图标', trigger: 'blur'}]
				}else{
					this.AddRules.vt_icon = [{required: true, message : '请选择图标', trigger: 'blur'}]
				}
				console.log("AddForm.vt_fid:"+this.AddForm.vt_fid);
			}else if(form == 'EditForm'){
				if(this.EditForm.vt_fid){
				this.EditRules.vt_icon = [{required: false, message : '请选择图标', trigger: 'blur'}]
				}else{
					this.EditRules.vt_icon = [{required: true, message : '请选择图标', trigger: 'blur'}]
				}
				console.log("EditForm.vt_fid:"+this.EditForm.vt_fid);
			}
		},

		/* 新增 */
		handleAdd(){
			this.AddDialogTableVisible = true;
		},
		customUploadCover(options){  
			//console.log(options);
			const formdata = new FormData();
			formdata.append('file', options.file);
			// 添加其他参数
			formdata.append('access_token', getToken());    
			this.$http.post(options.action,formdata,{emulateJSON:true}).then(res => {        
					if(res.body.code==500 || res.body.code==510)
					{   this.$refs.AddUpload.uploadFiles.splice(this.$refs.AddUpload.uploadFiles.indexOf(), 1);//移除预览文件
					this.$message({
								message: res.body.msg,
								type: 'error'
							});
						return false;
					}
					else
					{ 
						this.AddForm.vt_icon = res.body.content;  
					}  
			});       
		},
		/* 新增 -上传图片成功 */
		// successAddUpload(res,file,fileList) {
		// 	this.AddForm.vt_icon = res.content;
		// },
		/* 新增 -删除图片成功 */
		removeAddUpload(file,fileList) {
			this.AddForm.vt_icon = '';
		},
		/* 新增 -提交新增按钮 */
		submitAddForm(formName){
			this.$refs[formName].validate((valid) => {
				if(valid) {
					// 开启加载器
					const loading = this.$loading({
						lock: true,
						text: '正在保存中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var formdata = new FormData();
					formdata.append('access_token',getToken());
					formdata.append('vt_name',this.AddForm.vt_name);
					if(this.AddForm.vt_icon){ formdata.append('vt_icon',this.AddForm.vt_icon); }
					if(this.AddForm.vt_fid){ formdata.append('vt_fid',this.AddForm.vt_fid); }	
					this.$http.post(`${api.dev}/p/main/venue/type/save`,formdata,{emulateJSON:true}).then(res => {
						if(res.body.code == 200) {
							loading.close();
							this.$message({
								message: res.body.msg,
								type: 'success'
							});
							this.AddDialogTableVisible = false;
							this.loading = true;
							this.getInfo();
							this.getType();
							this.$refs[formName].resetFields(); // 清除表单验证规则 清空表单数据
						}else if(res.body.code == 500) {
							loading.close();
							this.$message({
								message: res.body.msg,
								type: 'error'
							});
						}
					})
				}
			})
		},
		/* 新增 -取消新增 */
		cancleAddForm(formName) {
			this.AddDialogTableVisible = false;
			this.$refs[formName].clearValidate(); // 清除表单验证规则
			this.AddFileList = [];
		},
		/* 新增 -关闭新增框 */
		AddDialogClosed(formName) {
			this.$refs[formName].resetFields(); // 清除表单验证规则
			this.AddFileList = [];
		},
		/* 新增 end */

		/* 编辑 */
		handleEdit(row) {
			this.EditForm.vt_id = row.vt_id;
			this.EditForm.vt_name = row.vt_name;
			if(row.vt_fid){
				this.EditForm.vt_fid = row.vt_fid;
			}else{
				this.EditForm.vt_fid = '';
			}
			if(row.vt_icon){
				this.EditForm.vt_icon = row.vt_icon;
				this.EditFileList = [{url: row.vt_icon}];
			}else{
				this.EditForm.vt_icon = '';
				this.EditFileList = [];
			}
			this.EditDialogTableVisible = true;
		},
		customEditUpload(options){  
        //console.log(options);
        const formdata = new FormData();
        formdata.append('file', options.file);
        // 添加其他参数
        formdata.append('access_token', getToken());    
        this.$http.post(options.action,formdata,{emulateJSON:true}).then(res => {        
                if(res.body.code==500 || res.body.code==510)
                {   this.$refs.EditUpload.uploadFiles.splice(this.$refs.EditUpload.uploadFiles.indexOf(), 1);//移除预览文件
                  this.$message({
                            message: res.body.msg,
                            type: 'error'
                        });
                    return false;
                }
                else
                {
					this.EditForm.vt_icon  = res.body.content; 
                }  
        });       
      },
		/* 编辑 -上传图片成功 */
		// successEditUpload(res,file,fileList) {
		// 	this.EditForm.vt_icon = res.content;
		// },
		/* 编辑 -删除图片成功 */
		removeEditUpload(file,fileList) {
			this.EditForm.vt_icon = '';
			console.log('this.EditForm.vt_icon:'+this.EditForm.vt_icon)
			this.EditFileList= [];
		},
		/* 编辑 -提交编辑按钮 */
		submitEditForm(formName){
			this.$refs[formName].validate((valid) => {
				if(valid) {
					// 开启加载器
					const loading = this.$loading({
						lock: true,
						text: '正在保存中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var formdata = new FormData();
					formdata.append('access_token', getToken());
					formdata.append('vt_id', this.EditForm.vt_id);
					formdata.append('vt_name', this.EditForm.vt_name);
					if(this.EditForm.vt_icon){
						var vt_icon = '/upload' + this.EditForm.vt_icon.split('/upload')[1];
						formdata.append('vt_icon', vt_icon);
					}
					if(this.EditForm.vt_fid){ formdata.append('vt_fid', this.EditForm.vt_fid); }	
					this.$http.post(`${api.dev}/p/main/venue/type/update`, formdata, {emulateJSON:true}).then(res => {
						if(res.body.code == 200) {
							loading.close();
							this.$message({
								message: res.body.msg,
								type: 'success'
							});
							this.EditDialogTableVisible = false;
							loading.close();
							this.getInfo();
							this.getType();
							this.$refs[formName].resetFields(); // 清除表单验证规则 清空表单数据
						}else if(res.body.code == 500) {
							loading.close();
							this.$message({
								message: res.body.msg,
								type: 'error'
							});
						}
					})
				}
			})
		},
		/* 编辑 -取消编辑 */
		cancleEditForm(formName) {
			this.EditDialogTableVisible = false;
			this.$refs[formName].clearValidate(); // 清除表单验证规则
			this.EditFileList = [];
		},
		/* 编辑 -关闭编辑框 */
		EditDialogClosed(formName) {
			this.$refs[formName].resetFields(); // 清除表单验证规则
			this.EditFileList = [];
		},

		/* 查看详情 */
		handleDetail(row){
			this.DetailForm.vt_id = row.vt_id;
			this.DetailForm.vt_name = row.vt_name;
			if(row.vt_fid){
				this.DetailForm.vt_fid = row.vt_fid;
			}else{
				this.DetailForm.vt_fid = '';
			}
			if(row.vt_icon){
				this.DetailForm.vt_icon = row.vt_icon;
				this.DetailFileList = [{url: row.vt_icon}];
			}else{
				this.DetailForm.vt_icon = '';
				this.DetailFileList = [];
			}
			this.DetailDialogTableVisible = true;
		},
		/* 编辑 -关闭编辑框 */
		DetailDialogClosed(formName) {
			this.$refs[formName].resetFields(); // 清除表单验证规则
			this.DetailFileList = [];
		},
		/* 删除 */
		handleDelete(row) {
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const loading = this.$loading({
					lock: true,
					text: '正在删除中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.$http.post(`${api.dev}/p/main/venue/type/delete`,{access_token: getToken(), vt_id : row.vt_id},{emulateJSON:true}).then(res => {
					if(res.body.code == 200) {
						loading.close();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getInfo();
					}else if (res.body.code == 500) {
						this.$message({
							message: res.body.msg,
							type: 'error'
						});
						loading.close();
					}else if(res.body.code == 510) {
						this.$message({
							message: res.body.msg,
							type: 'error'
						});
						removeToken();
						setTimeout(function () {
							this.$router.push({path: '/login'});
						},2000)
					}
				})
			})
		},

	},
	created() {
		this.getSubPermission();
		this.getLimit();
		this.getInfo();
		this.getType();
	},
	computed: {
		addUploadDisabled: function() {
			return this.AddForm.vt_icon != '';
		},
		editUploadDisabled: function() {
			return this.EditForm.vt_icon != '' ;
		},
		detailUploadDisabled: function() {
			return this.DetailForm.vt_icon != '' ;
		}
	},
	watch: {

	}
}
</script>

<style lang="stylus">
.venuecategory{
	.fr{ float: right; }
	.el-table__header thead tr th:first-child .cell{
		text-align: center!important;
	}
	i.el-select__caret.el-input__icon{
		line-height: 36px;
	}
}
</style>
